
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-13.818.09A3.821 3.821 0 0112 8.274c.643 0 1.254.159 1.782.445l.929-.929A5.047 5.047 0 0012 7a5.09 5.09 0 00-5.09 5.09H5l2.545 2.546 2.546-2.545H8.18zm8.272-2.545l-2.545 2.546h1.91A3.821 3.821 0 0112 15.909c-.643 0-1.254-.159-1.782-.445l-.929.929c.783.496 1.712.789 2.711.789a5.09 5.09 0 005.09-5.091H19l-2.546-2.546z","fill":"#000"}})])
          )
        }
      }
    